$('body').on('initScripts pageTransitionComplete', function() {
    const $html = $('html'),
        $body = $('body');

    // push gtm-event data-values on anchors to datalayer
    $body.on('click', '[data-gtm-event]', function() {
        let gtm_event = $(this).data('gtm-event'),
            page_url = $(location).attr('href');

        const event = {
            'event': 'gtm_event',
            'event_label': gtm_event,
            'event_url': page_url
        }

        if ($html.hasClass('env-local') || $html.hasClass('env-dbkdev')) {
            console.log(event); // development
        }

        if (typeof dataLayer !== 'undefined') {
            dataLayer.push(event); // production
        }
    });
});
